import React, { Component } from "react";
import {
  FaTimes,
  FaCheckCircle,
  FaPaperPlane,
} from "react-icons/fa";
import moment from "moment-hijri";
import { Button, message, Modal } from "antd";
import { connect } from "react-redux";
import {
  DeleteOrder,
  GetFinancingRequestDetails,
  UpdateFinancingRequestGeneralStatus,
} from "../../network/customer.network";
import { setUserRequest } from "../../redux/user/user.action";
import { RiErrorWarningFill } from "react-icons/ri"
const { confirm } = Modal;

class CalcStatuse extends Component {
  state = {
    loading: false,
    hideAceeptBtn: false,
    loadingCancelRate: false,
    StatusLogs: null,
  };
  componentDidMount() {
    // const { userRequest } = this.props;
    const { StatusLogs } = this.props;
    const filteredArr = StatusLogs?.filter(
      (v, i, a) =>
        a.findIndex(
          (t) =>
            t.FinancingRequestGeneralStatusId ===
            v.FinancingRequestGeneralStatusId
        ) === i
    );
    //console.log(filteredArr);
    filteredArr?.some((ele) => ele.FinancingRequestGeneralStatusId === 7) &&
      this.setState({ hideAceeptBtn: true });
    this.setState({ StatusLogs: filteredArr || [] });
  }

  handelGetFinancingRequestDetails = () => {
    const { userRequest } = this.props;
    GetFinancingRequestDetails(
      userRequest?.Id,
      (res) => {
        const filteredArr =
          res.data.model?.FinancingRequestGeneralStatusLogs?.filter(
            (v, i, a) =>
              a.findIndex(
                (t) =>
                  t.FinancingRequestGeneralStatusId ===
                  v.FinancingRequestGeneralStatusId
              ) === i
          );
        filteredArr?.some((ele) => ele.FinancingRequestGeneralStatusId === 7) &&
          this.setState({ hideAceeptBtn: true });

        this.setState({ StatusLogs: filteredArr, tableLoading: false });
        this.props.dispatch(setUserRequest(res.data.model));
      },
      (err) => {
        // console.log(err);
        this.setState({ tableLoading: false });
      }
    );
  };

  handelChangeGenralStatus = (stateId) => {
    const { userRequest } = this.props;
    this.setState({ loading: true });
    stateId === 23 && this.setState({ loadingOk: true })
    stateId === 25 && this.setState({ loadingCancel: true })
    UpdateFinancingRequestGeneralStatus(
      userRequest?.Id,
      stateId,
      (res) => {
        this.setState({ loadingOk: false, loading: false });
        if (stateId === 23 || stateId === 7) {
          message.success("تم ارسال الموافقه علي الحسبه بنجاح");
          this.handelGetFinancingRequestDetails();
        }
        if (stateId === 25) {
          // message.success("تم رفض الحسبه");
          this.setState({ loadingCancel: false });
          this.handelGetFinancingRequestDetails(); 
          // this.handeldeleteOrder();
        }
      },
      (err) => {
        this.setState({ loadingOk: false, loadingCancel: false, loading: false  });
        //console.log(err);
      }
    );
  };

  handeldeleteOrder = () => {
    this.setState({tableLoading : true})
    const { userRequest } = this.props;
    DeleteOrder(
      userRequest?.Id,  
      (res) => {
        message.success("تم الغاء الطلب بنجاح");
      },
      (error) => {
        this.setState({tableLoading : false})
      }
    );
  }

  handleShowConfirm(callback) {
    confirm({
      icon: <RiErrorWarningFill />,
      title: 'هل أنت متأكد من تنفيذ هذه الخطوة؟',      
      okText: 'نعم',
      cancelText: 'لا',
      onOk() {
        callback();
        console.log('OK');
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  render() {
    const { userRequest, selectedAccountId, FinancingRequestTypeId } =
      this.props;
    const { loading, StatusLogs, loadingCancel, loadingOk } =
      this.state;
    return (
      <>
        {StatusLogs?.map((Statuse) => {
          if (Statuse?.FinancingRequestGeneralStatusId === 1) {
            return (
              <div className={`
                  ${StatusLogs?.some((ele) => ele.FinancingRequestGeneralStatusId === 24) && "d-none"}
                  calc-timeline is-osool-statues`
              }>
                <div className="timeline-row-holder">
                  <p className="timeline--p">
                    تم ارسال الطلب وجاري العمل عليه 
                  </p>
                  <time className="timeline--time">
                    {moment
                      .utc(Statuse?.CreationDate)
                      .local()
                      .format("iYYYY/iM/iD - HH:MM")}
                  </time>
                </div>
              </div>
            );
          }
        })}

        {StatusLogs?.map((Statuse) => {
          if (Statuse?.FinancingRequestGeneralStatusId === 24) {
            return (
              <div className={`
              ${StatusLogs?.some((ele) => ele.FinancingRequestGeneralStatusId === 25 || ele.FinancingRequestGeneralStatusId === 23) && "d-none "} finance-actions`}>

                  <Button
                    type="primary"
                    size="large"
                    gost
                    className="xlg green-btn"
                    style={{width : "auto"}}
                    icon={<FaCheckCircle style={{marginLeft : 10}} />}
                    loading={loadingOk}
                    onClick={() => this.handleShowConfirm(() => this.handelChangeGenralStatus(23))}
                  >
                      الموافقه علي الحسبه
                  </Button>

                  <Button
                    type="primary"
                    size="large"
                    gost
                    className="xlg red-btn"
                    loading={loadingCancel}
                    onClick={() => this.handleShowConfirm(() => this.handelChangeGenralStatus(25))}
                    icon={<FaTimes style={{marginLeft : 10}} />}
                  >
                    رفض الحسبه 
                  </Button>
            </div>
            );
          }
        })}

        {StatusLogs?.map((Statuse) => {
          if (Statuse?.FinancingRequestGeneralStatusId === 38) {
            return (
              <>
                <div className="calc-timeline is-osool-statues">     
                  <div className="timeline-row-holder">
                    <p className="timeline--p">
                      تم ارسال حسبه جديده من  شركة الاصول
                    </p>
                    <time className="timeline--time">
                      {moment
                        .utc(Statuse?.CreationDate)
                        .local()
                        .format("iYYYY/iM/iD - HH:MM")}
                    </time>
                  </div>
                </div>
                <div className="calc-summary-holder calc-summary-send-holder support-reply">
                  <div className="summary-col">
                    <div className="summary-info-row">
                      <p>جهه التمويل</p>
                      <h5>{selectedAccountId?.FinancingAgency?.NameLT}</h5>
                    </div>
                    <div className="summary-info-row">
                      <p>التمويل</p>
                      <h5>
                        {selectedAccountId?.FinancingAmout} <span>ر.س</span>
                      </h5>
                    </div>
                    <div className="summary-info-row">
                      <p>نسبة الإستقطاع</p>
                      <h5>%{selectedAccountId?.CutOfRatio}</h5>
                    </div>
                    <div className="summary-info-row">
                      <p>نوع التمويل</p>
                      <h5>
                        {FinancingRequestTypeId === "1" ? "شخصي" : "عقاري"}
                      </h5>
                    </div>
                  </div>
                  <div className="summary-col">
                    <div className="summary-info-row">
                      <p>القسط</p>
                      <h5>
                        {Math.round(selectedAccountId?.MonthlyInstallment*100)/100} <span>ر.س</span>
                      </h5>
                    </div>
                    <div className="summary-info-row">
                      <p>مدة السداد بالاشهر</p>
                      <h5>
                        {selectedAccountId?.MonthsCount} <span>شهر</span>
                      </h5>
                    </div>
                    {FinancingRequestTypeId === '2' &&
                    <div className="summary-info-row">
                      <p>قسط الدعم</p>
                      <h5>
                        {selectedAccountId?.SupportInstallment}<span>ر.س</span>
                      </h5>
                    </div>
                    }                    
                    <div className="summary-info-row">
                      <p>الربح</p>
                      <h5>%{selectedAccountId?.AccountingRatioValue}</h5>
                    </div>
                    
                  </div>
                </div>
                { 
                userRequest?.FinancingRequestGeneralStatusLog?.FinancingRequestGeneralStatusId === 38 &&
                <div
                  className={`finance-actions ${ ``
                    // StatusLogs.some(
                    //   (ele) => ele.FinancingRequestGeneralStatusId === 23 || ele.FinancingRequestGeneralStatusId === 25 || ele.FinancingRequestGeneralStatusId === 10
                    // ) &&
                    //  " d-none " 
                  }`}
                >
                  <Button
                    type="primary"
                    size="large"
                    gost
                    className="xlg blue-btn accept-calc-btn"
                    icon={<FaPaperPlane />}
                    loading={loadingOk}
                    onClick={() => this.handleShowConfirm(() => this.handelChangeGenralStatus(23))}
                  >
                    موافقه علي الحسبة المعدله
                  </Button>
                  <Button
                    type="primary"
                    size="large"
                    gost
                    className="xlg red-btn"
                    loading={loadingCancel}
                    onClick={() => this.handleShowConfirm(() => this.handelChangeGenralStatus(25))}
                    icon={<FaTimes style={{marginLeft : 10}} />}
                  >
                    رفض الحسبه المعدله
                  </Button>
                </div>}
              </>
            );
          }
        })}

        {StatusLogs?.map((Statuse) => {
          if (Statuse?.FinancingRequestGeneralStatusId === 42) {
            return (
              <>
                <div className="calc-timeline support-reply">    
                  <div className="timeline-row-holder">
                    <p className="timeline--p">
                      تم ارسال حسبه جديده   
                    </p>
                    <time className="timeline--time">
                      {moment
                        .utc(Statuse?.CreationDate)
                        .local()
                        .format("iYYYY/iM/iD - HH:MM")}
                    </time>
                  </div>
                </div>
                <div className="calc-summary-holder calc-summary-send-holder support-reply">
                  <div className="summary-col">
                    <div className="summary-info-row">
                      <p>جهه التمويل</p>
                      <h5>{selectedAccountId?.FinancingAgency?.NameLT}</h5>
                    </div>
                    <div className="summary-info-row">
                      <p>التمويل</p>
                      <h5>
                        {selectedAccountId?.FinancingAmout} <span>ر.س</span>
                      </h5>
                    </div>
                    <div className="summary-info-row">
                      <p>نسبة الإستقطاع</p>
                      <h5>%{selectedAccountId?.CutOfRatio}</h5>
                    </div>
                    <div className="summary-info-row">
                      <p>نوع التمويل</p>
                      <h5>
                        {FinancingRequestTypeId === "1" ? "شخصي" : "عقاري"}
                      </h5>
                    </div>
                  </div>
                  <div className="summary-col">
                    <div className="summary-info-row">
                      <p>القسط</p>
                      <h5>
                        {Math.round(selectedAccountId?.MonthlyInstallment*100)/100} <span>ر.س</span>
                      </h5>
                    </div>
                    <div className="summary-info-row">
                      <p>مدة السداد بالاشهر</p>
                      <h5>
                        {selectedAccountId?.MonthsCount} <span>شهر</span>
                      </h5>
                    </div>
                    {FinancingRequestTypeId === '2' &&
                    <div className="summary-info-row">
                      <p>قسط الدعم</p>
                      <h5>
                        {selectedAccountId?.SupportInstallment}<span>ر.س</span>
                      </h5>
                    </div>
                    }                    
                    <div className="summary-info-row">
                      <p>الربح</p>
                      <h5>%{selectedAccountId?.AccountingRatioValue}</h5>
                    </div>
                  </div>
                </div>
                {/* { 
                userRequest?.FinancingRequestGeneralStatusLog?.FinancingRequestGeneralStatusId === 38 &&
                <div
                  className={`finance-actions ${ ``
                    // StatusLogs.some(
                    //   (ele) => ele.FinancingRequestGeneralStatusId === 23 || ele.FinancingRequestGeneralStatusId === 25 || ele.FinancingRequestGeneralStatusId === 10
                    // ) &&
                    //  " d-none " 
                  }`}
                >
                  <Button
                    type="primary"
                    size="large"
                    gost
                    className="xlg blue-btn accept-calc-btn"
                    icon={<FaPaperPlane />}
                    loading={loading}
                    onClick={() => this.handelChangeGenralStatus(23)}
                  >
                    موافقه علي الحسبة المعدله
                  </Button>
                  <Button
                    type="primary"
                    size="large"
                    gost
                    className="xlg red-btn"
                    loading={loadingCancel}
                    onClick={() => this.handelChangeGenralStatus(25)}
                    icon={<FaTimes style={{marginLeft : 10}} />}
                  >
                    رفض الحسبه المعدله
                  </Button>
                </div>} */}
              </>
            );
          }
        })}

        

        {/* {StatusLogs?.map((Statuse) => {
          if (Statuse?.FinancingRequestGeneralStatusId === 15) {
            return (
              <div className="calc-timeline success">
                <div className="timeline-row-holder">
                  <p className="timeline--p">
                    {Statuse?.FinancingRequestGeneralStatus?.NameLT}
                  </p>
                  <time className="timeline--time">
                    {moment
                      .utc(Statuse?.CreationDate)
                      .local()
                      .format("iYYYY/iM/iD - HH:MM")}
                  </time>
                </div>

                <div className="calc-summary-holder calc-summary-send-holder support-reply">
                  <div className="summary-col">
                    <div className="summary-info-row">
                      <p>القيمه</p>
                      <h5>
                        {userRequest?.RealestateCost} <span> ر.س</span>
                      </h5>
                    </div>
                  </div>
                  <div className="summary-col">
                    <div className="summary-info-row">
                      <p>التفاوت</p>
                      <h5>
                        {userRequest?.Disparity} <span> ر.س</span>
                      </h5>
                    </div>
                  </div>
                </div>
                
              </div>
            );
          }
        })} */}



        {/* {StatusLogs?.map((Statuse) => {
          if (Statuse?.FinancingRequestGeneralStatusId === 17) {
            return (
              <>
                <div
                  className={`docs-holder calc-summary-send-holder 
              
              `}
                >
                  <h6 className="docs-title">الموافقه النهائيه</h6>
                  <div className="doc-body">
                    <div className="browse-file-content">
                      <FaFilePdf />
                      <div className="browse-file-text">
                        <p>file.pdf</p>
                        <span>120.kb</span>
                      </div>
                    </div>
                    <div className="doc-action">
                      <a
                        href={userRequest?.FinalApprovmentFileUrl}
                        target="_blank"
                      >
                        <FaEye style={{ color: "#C2A062" }} />
                      </a>
                      <a
                        href={userRequest?.FinalApprovmentFileUrl}
                        target="_blank"
                      >
                        <FaDownload
                          style={{ color: "#06ACCC", margin: "0 14px" }}
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </>
            );
          }
        })} */}

      </>
    );
  }
}

const mapStateToProps = (state) => ({
  userRequest: state.user.userRequest,
});
export default connect(mapStateToProps)(CalcStatuse);
